import React, { useEffect } from "react";
import { Odometer } from "../../../common/data/service-proxies";
import { useForm } from "react-final-form";

interface IVehicleDefaultValuesHandler {
  odometer?: Odometer | null;
}

export const VehicleDefaultValuesHandler = (
  props: IVehicleDefaultValuesHandler
) => {
  const { odometer } = props;

  const form = useForm();
  useEffect(() => {
    if (odometer) {
      form.change("odometer", odometer);
    }
  }, [odometer, form]);

  return <></>;
};
